<template>
  <b-tabs>
    <b-tab title="Requested Parts">
      <crfq-parts-tab :crfqId="requirementId" />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_ALL_OFFERS)" :active="routehash == '#offers'">
      <template v-slot:title>
        Offers &nbsp;<b-badge variant="primary">{{ offersList.length }}</b-badge>
      </template>
      <offers-tab crfqLineId="requirementLineId" :reqLineId="requirementLineId" :partId="partId" v-if="checkClaim(CAN_VIEW_ALL_OFFERS)"/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        Sources &nbsp;<b-badge variant="primary">{{ sourcesList.length }}</b-badge>
      </template>
      <sources-tab :reqLineId="requirementLineId" />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_INVENTORY)">
      <template v-slot:title>
        Availablility &nbsp;<b-badge variant="primary">{{ inventoryListForPart.length }}</b-badge>
      </template>
      <inventory-tab :reqLineId="requirementLineId" :partId="partId" v-if="checkClaim(CAN_VIEW_INVENTORY)" />
    </b-tab>
    <b-tab v-if="checkClaim(CAN_VIEW_PARTS)">
      <template v-slot:title>
        Cross/Alternatives &nbsp;<b-badge variant="primary">{{ alternativesList.length }}</b-badge>
      </template>
      <alternative-list :partId="partId" :crfqLineId="requirementLineId" :gridId="getGridId('alternative')"/>
    </b-tab>
    <b-tab>
      <template v-slot:title>
        On Order &nbsp;<b-badge variant="primary">{{ purchaseOrderLines.length }}</b-badge>
      </template>
      <orders-tab :reqLineId="requirementLineId" :partId="partId" v-if="checkClaim(CAN_VIEW_ALL_POS)"/>
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { GRID_ID } from '@/shared/constants';
import CrfqPartsTab from '@/pages/Requirements/components/Tabs/CrfqParts';
import OffersTab from '@/pages/Requirements/components/Tabs/Offers';
import SourcesTab from '@/pages/Requirements/components/Tabs/Sources';
import InventoryTab from '@/pages/Requirements/components/Tabs/Inventory';
import AlternativeList from '@/shared/components/Alternatives';
import OrdersTab from '@/pages/Requirements/components/Tabs/OnOrder';

export default {
  components: {
    CrfqPartsTab,
    OffersTab,
    SourcesTab,
    InventoryTab,
    AlternativeList,
    OrdersTab
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    currentPart: function(part) {
      if (!part.id) {
        this.$router.push({
          name: 'requirements.crfq',
          params: { crfqId: this.$route.params.crfqId },
        });
      }
    },
  },
  computed: {
    ...mapGetters('requirementAdd', [
      'currentPart',
    ]),
    ...mapGetters('offers', ['offersList']),
    ...mapGetters('requirements', ['sourcesList']),
    ...mapGetters('inventory', [ 'inventoryListForPartById' ]),
    ...mapGetters('alternatives', ['alternativesList' ]),
    ...mapGetters('purchaseorders', [ 'purchaseOrderLines' ]),
    inventoryListForPart() {
      return this.inventoryListForPartById(this.partId);
    },
    requirementId() {
      return this.$route.query.crfqId;
    },
    requirementLineId() {
      return this.$route.query.crfqLineId;
    },
    partId() {
      return this.$route.query.partId;
    },
    routehash() {
      return this.$route.hash;
    }
  },
  methods:{
    getGridId(tabName){
      switch (tabName) {
          case 'alternative':
              return GRID_ID.REQUIREMENT_ALTERNATIVES
            break
      }
    }
  }
};
</script>
